import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import request from "./utils/request";
import AppImage from './components/AppImage.vue';

import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';

/*图片预览组件*/
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

import ElementUI from 'element-ui';                      // 引入element-ui
import 'element-ui/lib/theme-chalk/index.css';           // element-ui的css样式要单独引入
Vue.use(ElementUI);                                      // 这种方式引入了ElementUI中所有的组件


Vue.prototype.request = request;
Vue.component('AppImage', AppImage);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
